export default "skymp5-front/46e7c235111fa294ae294e52361b1a64.svg";